"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "@opensea/next-themes";
import { ToggleButtonGroup, ToggleButtonGroupItem, Tooltip } from "@opensea/ui-kit";
import { useIsHydrated } from "@opensea/ui-kit/hooks";
import { Contrast, DarkMode, LightMode } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
export function PageFooterThemeToggle() {
  const $ = _c(15);
  const {
    theme,
    setTheme
  } = useTheme();
  const isHydrated = useIsHydrated();
  const [playSelect] = usePlaySound(Sound.Select);
  const t = useTranslations("PageFooterThemeToggle");
  const t0 = isHydrated ? "hydrated" : "not-hydrated";
  let t1;
  if ($[0] !== playSelect || $[1] !== setTheme) {
    t1 = value => {
      setTheme(value);
      playSelect();
    };
    $[0] = playSelect;
    $[1] = setTheme;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isHydrated ? theme : "system";
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ToggleButtonGroupItem className="basis-1/3" icon={LightMode} value="light" />;
    t4 = <ToggleButtonGroupItem className="basis-1/3" icon={DarkMode} value="dark" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t("system");
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="basis-1/3"><ToggleButtonGroupItem className="w-full" icon={Contrast} value="system" /></span>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <Tooltip content={t5}>{t6}</Tooltip>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t7) {
    t8 = <ToggleButtonGroup key={t0} onValueChange={t1} size="sm" value={t2}>{t3}{t4}{t7}</ToggleButtonGroup>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}